
import SearchTips from './search-tips.vue'
import DeptTree from './dept-tree'
import commonMixins from './mixins'
import {
  getPosterity,
} from '../query-table/utils'
import './style/dept-select.scss'

const PROPS = {
  value: String,
  valueKey: {
    type: String,
    default: 'id'
  },
  containLeaf: { // 是否显示”是否包含子节点“
    type: Boolean,
    default: true
  },
  posterity: Function, // 勾选“是否包含子节点”时，返回所有后代节点
  formatData: Function, // 过滤保存数据
  preloadDeptTree: { // 是否预加载组织树
    type: Boolean,
    default: true
  },
  popperProps: {
    type: Object,
    default: () => ({})
  }
}

export default {
  name: 'KyeDeptSelect',
  props: PROPS,
  mixins: [commonMixins],
  data () {
    return {
      visible: false,
      checked: true,
      cacheData: {},
      selectedDeptName: '',
      departmentName: ''
    }
  },
  computed: {
    selectedPlaceholder () {
      return this.selectedDeptName ? this.selectedDeptName : undefined
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.initTree()
        } else {
          const departmentName = this.cacheData.name || ''
          this.selectedDeptName = ''
          this.departmentName = departmentName
          this.blur(departmentName)
        }
      }
    }
  },
  methods: {
    handleInput (val) {
      this.visible = val
    },
    onSave () {
      const node = this.$refs.deptTree.getCurrentNode()
      if (node) {
        const deptMap = this.deptMap || {}
        const authTree = this.authTree || []
        let value = null
        let id = node.id
        if (!deptMap[id]) {
          return this.$message.warning('请先选择')
        }
        let ids = deptMap[id].children
        if (this.checked && ids) {
          if (this.posterity) {
            value = getPosterity(deptMap, [id], ids)
          } else {
            value = [id].concat(ids)
          }
        } else {
          value = [id]
        }
        // 格式化数据
        const originValue = value
        const formatData = this.formatData
        if (value && formatData) {
          value = formatData({ value, map: deptMap, tree: authTree })
        }
        let data = {
          value,
          originValue, // 未格式化之前的value
          node, // 选中节点
          leaf: this.checked, // 是否包含
          deptMap: deptMap, // 当前tree数据扁平化数据
          tree: authTree // tree
        }
        this.cacheData = node
        this.focus()
        this.$emit('input', node[this.valueKey])
        this.$emit('change', data)
        this.showPopver(false)
      } else {
        this.$message.warning('请先选择')
      }
    },
    onCancel () {
      this.showPopver(false)
    },
    showPopver (visible = true) {
      this.visible = visible
    },
    blur (value) {
      this.$refs.searchTips && this.$refs.searchTips.blur(value)
    },
    clearDepartment () {
      this.selectedDeptName = ''
      this.departmentName = ''
      this.departmentId = ''
      this.cacheData = {}
      this.$emit('input', '')
      this.$emit('change', {})
    },
    nodeClick (data) {
      this.departmentName = ''
      this.selectedDeptName = data.name
    }
  },
  render () {
    const { popperProps } = this.$props
    // popovers属性
    const popoverAttrs = {
      props: {
        ...(popperProps || {}),
        trigger: 'click',
        width: '400',
        placement: 'bottom-start',
        popperClass: `public-kye-dept-popper ${popperProps.popperClass ? popperProps.popperClass : ''}`,
        transition: 'el-zoom-in-top',
        value: this.visible,
      },
      on: {
        input: (val) => this.handleInput(val),
      }
    }

    const renderSearchTips = () => {
      const props = {
        value: this.departmentName,
        axios: this.axios,
        placeholder: this.selectedPlaceholder,
        searchUrl: this.searchDeptUrl,
        formatResult: this.formatResult,
        searchParams: this.searchDeptParams,
        showArrowIcon: true
      }
      const attrs = {
        props,
        ref: 'searchTips',
        on: {
          clearDepartment: this.clearDepartment,
          chooseDepartment: this.chooseDepartment,
          input: (val) => this.departmentName = val,
        },
        slot: 'reference'
      }
      return (
        <SearchTips
          { ...attrs }>
        </SearchTips>
      )
    }

    const renderFooter = () => {
      const props = {
        checked: this.checked
      }
      const attrs = {
        props,
        class: 'footer-box__checkbox',
        on: {
          input: val => this.checked = val,
        }
      }
      return (
        <div class="footer-box">
          { this.containLeaf && <el-checkbox { ...attrs }>是否包含子节点</el-checkbox> }
          <div class="footer-box__btn">
            <el-button type="primary" hotkey="ctrl+s" onClick={ this.onSave }>确定(S)</el-button>
            <el-button onClick={ this.onCancel }>取消</el-button>
          </div>
        </div>
      )
    }

    const renderDept = () => {
      const props = {
        init: this.init,
        load: this.load,
        authTree: this.authTree,
        accordion: this.accordion,
        defaultExpandedKeys: this.expandedKeys
      }
      const attrs = {
        props,
        class: 'tree-box',
        ref: 'deptTree',
        on: {
          nodeClick: this.nodeClick
        }
      }
      return (
        <div class="public-kye-dept-popper__content" v-loading={ this.load }>
          <div class="header-box">{ this.bakMonthLabel }</div>
          <DeptTree
            { ...attrs }>
          </DeptTree>
          { renderFooter() }
        </div>
      )
    }

    return (
      <div class="public-kye-dept-select el-select">
        <el-popover
          { ...popoverAttrs }>
          { renderSearchTips() }
          { renderDept() }
        </el-popover>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-dept/dept-select.js